/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { ChangePassword } from './components/ChangePassword'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { TwoFactorAuthentication } from './components/TwoFactorAuthentication'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-musa-cream')
    return () => {
      document.body.classList.remove('bg-musa-cream')
    }
  }, [])

  return (
    <div
      className='auth-musa d-flex flex-column flex-column-fluid position-relative overflow-hidden'
      style={{backgroundImage: `url(${toAbsoluteUrl('/media/brand/pattern-login.png')})`}}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20 position-relative'>
        {/* begin::Logo */}
        <a href='#' className='mb-8'>
          <img
            alt='Musa'
            src={toAbsoluteUrl('/media/brand/musa-wordmark-coral.svg')}
            className='h-60px'
          />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded-4 shadow-sm p-10 p-lg-15 mx-auto auth-musa-card'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<ChangePassword />} />
      <Route path='code-verification' element={<TwoFactorAuthentication />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export { AuthPage }
